export default {
  BothSides: -1, // Hai bên
  InDebt: 1, // Nợ
  Yes: 2, // Có
};
